import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const STORE_PATH = "/stock/v1";

export const getStoreApi = async (params, options = {}) => await getRequest(STORE_PATH, params, options);

export const getStoreByIdApi = async (params, options = {}) => await getRequest(`${STORE_PATH}/${params?.id}`);

export const addStoreApi = async (body) => await postRequest(STORE_PATH, body);

export const updateStoreApi = async (body) =>
  await putRequest(`${STORE_PATH}/${body?._id}`, body);

export const deleteStoreByIdApi = async (id) =>
  await deleteRequest(`${STORE_PATH}/${id}`);
